import React from "react";
import styles from '../TemplatesPreview.module.scss';

const ElementUrl = ({ value }) => {
  return (
    <div style={{display: 'flex'}}>
      <div className={styles.groupName}>Сайт:&nbsp;</div>
      <div className={styles.groupCOnteiner}>
        <a href={value} target="_blank" rel="noopener noreferrer" className={styles.groupValue}>{value}</a>
      </div>
    </div>
  )
}

export default ElementUrl;